import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import companiesMgmt from './companiesMgmt.json';
import kanban from './kanban.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import featureAnnouncements from './featureAnnouncements.json';
import guidedTours from './guidedTours.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import inbox from './inbox.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import customActions from './customActions.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import brandsSettings from './brandsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import groups from './groups.json';
import toolzzChat from './toolzzChat.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...companiesMgmt,
  ...kanban,
  ...csatMgmt,
  ...emoji,
  ...featureAnnouncements,
  ...guidedTours,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...inbox,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...customActions,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...brandsSettings,
  ...whatsappTemplates,
  ...groups,
  ...toolzzChat,
};
